import CButton from "components/CButton";
import CDialog from "components/CDialog";
import CTextField from "components/CTextField";
import useDocumentUploadForm from "./useDocumentUploadForm";
import CDialogTransition from "components/CDialogTransition";
import { Box, Typography, useTheme } from "@mui/material";

type DialogProps = {
  open: boolean;
  handleClose: () => void;
};

const UploadDocumentDialog: React.FC<DialogProps> = ({ open, handleClose }) => {
  const theme = useTheme();
  const form = useDocumentUploadForm(handleClose);

  return (
    <CDialog
      maxWidth="md"
      title={"Upload Insurance Policy"}
      open={open}
      onClose={handleClose}
      TransitionComponent={CDialogTransition}
      aria-labelledby="customized-dialog-title"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Typography mb={2} color={theme.palette.text.secondary} fontStyle={""}>
        Please upload your Insurance Policy in PDF format
      </Typography>
      <form onSubmit={form.uploadDocument}>
        <CTextField
          fullWidth
          sx={{
            pb: 2,
          }}
          error={form.formState.errors.document?.message}
          type={"file"}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            form.convertToBase64(e);
          }}
          inputProps={{
            accept: [".pdf"],
            ignore: ".svg",
          }}
        />
        {form.errorSubmit && (
          <Typography marginTop={2} color={theme.palette.error.main}>
            {form.errorSubmit}
          </Typography>
        )}
        <Box flexDirection={"row"} display={"flex"} mt={4}>
          <CButton
            type="reset"
            fullWidth
            variant="outlined"
            sx={{ mr: 2 }}
            disabled={form.loading}
            onClick={() => form.onReset()}
          >
            Discard
          </CButton>
          <CButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ ml: 2 }}
            loading={form.loading}
          >
            Save
          </CButton>
        </Box>
      </form>
    </CDialog>
  );
};

export default UploadDocumentDialog;
